/**
 * Shared value formatting for template bodies.
 *
 * Every filled-in variable in a template renders through `v` (text) or
 * `num` (numbers). Centralising them here — instead of redefining the
 * pair in every template — means whitespace handling is consistent and
 * fixable in one place (ACT-01).
 *
 * `v` trims the ends and collapses runs of horizontal whitespace, while
 * preserving intentional line breaks (some values render inside
 * `whitespace-pre-line` clause boxes). This stops a stray leading or
 * trailing space — common in copy-pasted input and R2 upload-extraction
 * — from producing a double space before the value or a space before a
 * following period.
 */
/** Underline shown in place of an unfilled value. */
export const PLACEHOLDER = '____________';
export function v(val) {
    if (val === null || val === undefined)
        return PLACEHOLDER;
    const normalized = String(val)
        .replace(/[^\S\n]+/g, ' ')
        .replace(/[ \t]*\n[ \t]*/g, '\n')
        .trim();
    return normalized === '' ? PLACEHOLDER : normalized;
}
export function num(val) {
    if (typeof val !== 'number')
        return PLACEHOLDER;
    return val.toLocaleString('sv-SE');
}
//# sourceMappingURL=format.js.map